export class GitFileResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "blobSha",
            "baseName": "blobSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "size",
            "baseName": "size",
            "type": "number",
            "format": ""
        },
        {
            "name": "isReadOnly",
            "baseName": "isReadOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "readOnlyReason",
            "baseName": "readOnlyReason",
            "type": "FileReadOnlyReason",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitFileResponse.attributeTypeMap;
    }
    constructor() {
    }
}
